import React, { useEffect, useState, createContext } from 'react';
import { useMatch } from 'react-router';
import { auth, signInWithGoogle, logout, subscribeTo, handleRedirectResult } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { find } from 'lodash-es';
import { capitalize } from 'lodash-es';
import Nav from 'nav/nav';
import User from 'user/user';

import './app.scss';

const UserContext = createContext({
  currentUser: null,
  users: [],
});

const App = () => {
  const [users, setUsers] = useState({});
  const [currentUser, setCurrentUser] = useState(null);
  const match = useMatch('/:name');
  const userName = match?.params?.name;
  
  useEffect(() => {
    let unsubscribeUsers = null;

    // Handle redirect result from OAuth redirect flow (needed for iOS)
    handleRedirectResult();

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        user.firstName = user.displayName.split(' ')[0];
        setCurrentUser(user);
      } else {
        setCurrentUser(null);
      }

      // subscribe to /users once we know auth state so DB rules that require auth won't block the read
      if (!unsubscribeUsers) {
        unsubscribeUsers = subscribeTo('/users', (snapshot) => {
          const users = snapshot.val();

          if (snapshot.exists()) {
            setUsers(users);
          } else {
            setUsers({});
          }
        });
      }
    });

    return () => {
      if (typeof unsubscribeAuth === 'function') unsubscribeAuth();
      if (typeof unsubscribeUsers === 'function') unsubscribeUsers();
    };
  }, []);

  const getUser = (name) => {
    let user = find(users, { name });

    if (!user) return null;

    return <User {...user} />;
  };

  const authLink = () => {
    if (currentUser) {
      return (
        <div className="app-authLink-wrapper">
          <div>Hello {capitalize(currentUser.firstName)}</div>
          <a
            href="#"
            className="app-authLink"
            onClick={() => {
              logout();
              setCurrentUser(null);
            }}
          >
            Sign Out
          </a>
        </div>
      );
    }

    return (
      <div className="app-authLink-wrapper">
        <a href="#" className="app-authLink" onClick={signInWithGoogle}>
          Sign In with Google
        </a>
      </div>
    );
  };

  const ifAuthed = (authedContent, unAuthedContent) => {
    if (currentUser) return authedContent;

    return unAuthedContent || null;
  };

  return (
    <UserContext.Provider value={{ currentUser, users }}>
      <div>
        <div className="app-content">
          <header className="app-header">
            <h1 className="app-title">Tarr Family Gift List</h1>
            {authLink()}
            {ifAuthed(<Nav users={users} />)}
          </header>
          {ifAuthed(getUser(userName))}
        </div>
      </div>
    </UserContext.Provider>
  );
};

export default App;
export { UserContext };
